/* /assets/section-landing-sticky-atc.js */

if (!customElements.get('landing-sticky-atc')) {
  customElements.define(
    'landing-sticky-atc',
    class LandingStickyAtc extends HTMLElement {
      constructor() {
        super();
        this._heroObserver = null;
        this._finalObserver = null;
        this._heroCtaVisible = true;
        this._finalCtaVisible = false;
        this._visibleFinalEls = new Set();
      }

      connectedCallback() {
        this._observeHeroCta();
        this._observeFinalSections();
        this._bindCtaClick();
      }

      disconnectedCallback() {
        this._heroObserver?.disconnect();
        this._finalObserver?.disconnect();
        this._heroObserver = null;
        this._finalObserver = null;
      }

      _observeHeroCta() {
        const heroEl = document.querySelector('.landing-hero__cta-wrap');

        if (!heroEl) {
          // No hero CTA found — show the bar from the start
          this._heroCtaVisible = false;
          this._updateVisibility();
          return;
        }

        this._heroObserver = new IntersectionObserver(
          ([entry]) => {
            this._heroCtaVisible = entry.isIntersecting;
            this._updateVisibility();
          },
          { threshold: 0 }
        );

        this._heroObserver.observe(heroEl);
      }

      _observeFinalSections() {
        // Covers all landing-page final-pricing section variants
        const selectors = [
          '.landing-pricing-cta-section',
          '.landing-final-pricing-section',
          '.lp2-final-pricing-section',
        ];

        const elements = selectors.flatMap((sel) =>
          Array.from(document.querySelectorAll(sel))
        );

        if (elements.length === 0) return;

        this._finalObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this._visibleFinalEls.add(entry.target);
              } else {
                this._visibleFinalEls.delete(entry.target);
              }
            });
            this._finalCtaVisible = this._visibleFinalEls.size > 0;
            this._updateVisibility();
          },
          { threshold: 0 }
        );

        elements.forEach((el) => this._finalObserver.observe(el));
      }

      _updateVisibility() {
        const shouldShow = !this._heroCtaVisible && !this._finalCtaVisible;
        this.classList.toggle('is-visible', shouldShow);
        this.setAttribute('aria-hidden', String(!shouldShow));
      }

      _bindCtaClick() {
        const cta = this.querySelector('[data-scroll-cta]');
        if (!cta) return;

        cta.addEventListener('click', (e) => {
          const target = this.dataset.scrollTarget;
          if (!target) return;

          // Real URL — let the browser navigate normally
          if (target.startsWith('/') || target.startsWith('http')) return;

          e.preventDefault();

          const el = document.querySelector(target);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
    }
  );
}
